var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('PageTemplate',{attrs:{"title":_vm.$t('monitor.pageTitle'),"description":_vm.$t('monitor.pageSubtitle'),"to":{ name: _vm.RouteName.Monitoring }}},[_c('template',{slot:"content"},[_c('MonitoringOverview')],1)],2)}
var staticRenderFns = []

export { render, staticRenderFns }